module.exports = __webpack_public_path__ + "static/media/plugins-optimized.291e364d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/slides/05-why-gatsby/images/plugins-optimized.jpg
// module id = 956
// module chunks = 0